import { AxiosResponse } from 'axios';
import { AxiosInstance } from 'axios';
import { Conditions } from '@/store/sleepings/Conditions';
import { ConditionsRepository } from '@/model/repository/manager/childcare-document/sleepings/ConditionsRepository';

export default (Repository: AxiosInstance) =>
  (resource: string): ConditionsRepository => ({
    async getConditions(date: string, groupId: string): Promise<Conditions> {
      return new Promise<Conditions>((resolve, reject) => {
        Repository.get(`${resource}/date/${date}`, { params: { groupId } })
          .then((res: AxiosResponse<any>) => {
            resolve(new Conditions(res.data.data));
          })
          .catch((err) => {
            const status = err.response ? err.response.status : null;
            reject({ err, status });
          });
      });
    },

    async putConditions(date: string, groupId: string, conditions: Conditions): Promise<any> {
      return new Promise<any>((resolve, reject) => {
        Repository.put(
          `${resource}/date/${date}`,
          {
            RequestPutSleepingConditionsDto: {
              temperature: conditions.getTemperature(),
              humidity: conditions.getHumidity(),
              weather: conditions.getWeather(),
            },
          },
          { params: { groupId } }
        )
          .then((res: AxiosResponse<any>) => {
            resolve(res.data.data);
          })
          .catch((err) => {
            const status = err.response ? err.response.status : null;
            reject({ err, status });
          });
      });
    },
  });
